import React, { Component } from 'react';
import UpdateRuleForm from './UpdateRuleForm';
import * as actions from "../../Actions/rules";
import { connect } from "react-redux";
import { PERCENTAGEANDAMOUNT, PERCENTAGE } from "./constants.js";

class RuleModal extends Component {

    componentDidMount() {
        const ruleId = (this.props.transaction && this.props.transaction.Coding[0] && this.props.transaction.Coding[0].CodingSource) || null
        if (ruleId) {
            this.props.getRules(localStorage.getItem("bookid"), ruleId);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.status.posting && nextProps.status.success) {
            this.props.closeModal();
            this.props.clearStatus();
        }
    }
    componentWillUnmount() {
        this.props.clearRule();
    }

    switchRule = (ruleId) => {
        this.props.getRules(localStorage.getItem("bookid"), ruleId, ruleId);
    }

    handleSaveRule = (values) => {
        if (values.Description && (
            (values.transactionAmount && values.amountOperator) ||
            (values.transactionType && values.typeOperator) ||
            (values.transactionDescription && values.descriptionOperator) ||
            (values.transactionReference && values.referenceOperator))) {
            const rule = {
                RuleId: values.RuleGuid,
                Description: values.Description,
                OrderId: this.props.rules.length,
                Definition: [],
                PaymentReceipt: { Description: '', Allocations: [] }
            };

            rule.Definition.push({ Field: 'MoneyInOut', Operator: values.MoneyInOut, Value: '' });

            if (values.amountOperator && values.transactionAmount) {
                rule.Definition.push({
                    Field: 'Amount',
                    Operator: (typeof values.amountOperator === 'string') ? values.amountOperator : values.amountOperator.value,
                    Value: Math.abs(values.transactionAmount * 1).toString()
                });
            };

            if (values.descriptionOperator && values.transactionDescription) {
                rule.Definition.push({
                    Field: 'Description',
                    Operator: (typeof values.descriptionOperator === 'string') ? values.descriptionOperator : values.descriptionOperator.value,
                    Value: values.transactionDescription.toString().replace(/'/g, "''")
                });
            };

            if (values.referenceOperator && values.transactionReference) {
                rule.Definition.push({
                    Field: 'Reference',
                    Operator: (typeof values.referenceOperator === 'string') ? values.referenceOperator : values.referenceOperator.value,
                    Value: values.transactionReference.toString().replace(/'/g, "''")
                });
            };

            if (values.typeOperator && values.transactionType) {
                rule.Definition.push({
                    Field: 'Type',
                    Operator: (typeof values.typeOperator === 'string') ? values.typeOperator : values.typeOperator.value,
                    Value: values.transactionType.toString().replace(/'/g, "''")
                });
            };

            const isEqualTo = values.amountOperator && (values.amountOperator === 'Equal' || (values.amountOperator.value === 'Equal'));
            const reverseFactor = values.MoneyInOut === "0" ? -1 : 1;
            const allocateByPercent = values.allocateBy === PERCENTAGE;
            const allocateByPercentAndAmount = values.allocateBy === PERCENTAGEANDAMOUNT;
            const remainder = isEqualTo ? [] : values.Remainder.map(item => ({
                AccountCode: (typeof item.AccountCode === 'string') ? item.AccountCode : item.AccountCode.value,
                ...(item.Percentage && { Percentage: item.Percentage * 1 }),
                TaxCode: (!item.TaxCode) ? undefined : (typeof item.TaxCode === 'string') ? item.TaxCode : item.TaxCode.value,
                Description: item.Description || '',
                Classification: (!item.Classification || typeof item.Classification === 'string') ? item.Classification : item.Classification.value,
                Contact: (!item.Contact || typeof item.Contact === 'string') ? item.Contact : item.Contact.value
            }));
            const allocation = (!isEqualTo && allocateByPercent) ? [] : values.Allocation.map(item => ({
                AccountCode: (typeof item.AccountCode === 'string') ? item.AccountCode : item.AccountCode.value,
                ...(!isEqualTo && item.Amount && { Amount: item.Amount * reverseFactor }),
                ...(isEqualTo && item.Percentage && { Percentage: item.Percentage * 1 }),
                TaxCode: (!item.TaxCode) ? undefined : (typeof item.TaxCode === 'string') ? item.TaxCode : item.TaxCode.value,
                Description: item.Description || '',
                Classification: (!item.Classification || typeof item.Classification === 'string') ? item.Classification : item.Classification.value,
                Contact: (!item.Contact || typeof item.Contact === 'string') ? item.Contact : item.Contact.value
            }));
            if (isEqualTo) {
                rule.PaymentReceipt.Allocations = [ ...allocation ];
            } else {
                if (allocateByPercentAndAmount) rule.PaymentReceipt.Allocations = [ ...allocation, ...remainder ].sort((a, b) => (a.Percentage && !b.Percentage) ? 1 : -1);
                else rule.PaymentReceipt.Allocations = [ ...remainder ];
            }
            this.props.postRule(rule, localStorage.getItem("bookid"), this.props.dateRange, this.props.account);
        }
    }

    render() {
        const { transactionCodes, closeModal, transaction, rules, classification, contacts, isRah, taxTracking, account } = this.props;
        const ruleId = (transaction && transaction.Coding[0] && transaction.Coding[0].CodingSource) || null;
        let ruleValues = {};

        if (ruleId) {
            const rule = rules[0];
            if (!rule) return null;

            const definition = rule.Definition.reduce((definitionObj, item) => {
            switch (item.Field) {
                case 'Amount':
                    definitionObj.amountOperator = item.Operator;
                    definitionObj.transactionAmount = Math.abs(item.Value);
                    break;

                case 'Description':
                    definitionObj.descriptionOperator = item.Operator;
                    definitionObj.transactionDescription = item.Value;
                    break;

                case 'Type':
                    definitionObj.typeOperator = item.Operator;
                    definitionObj.transactionType = item.Value;
                    break;

                case 'Reference':
                    definitionObj.referenceOperator = item.Operator;
                    definitionObj.transactionReference = item.Value;
                    break;

                default:
                    return definitionObj;
                }
                return definitionObj;
            }, {});
            const isEqualTo = definition.amountOperator && (definition.amountOperator === 'Equal');
            const isPercentageAndAmount = rule.Allocation && rule.Allocation.some(item => item.Amount);
            let allocation;
            let remainder;
            if (isEqualTo) {
                allocation = rule.Allocation && rule.Allocation.map((item => ({ ...item, Amount: (Math.round((item.Percentage * definition.transactionAmount / 100) * 100) / 100).toFixed(2) })));
            } else {
                if (isPercentageAndAmount) {
                    allocation = rule.Allocation && rule.Allocation.filter(item => item.Amount).map(item => ({ ...item, Amount: Math.abs(item.Amount) }));
                }
                remainder = rule.Allocation && rule.Allocation.filter(item => item.Percentage);
            }
            ruleValues = { ...rule, ...definition, allocateBy: isPercentageAndAmount ? PERCENTAGEANDAMOUNT : PERCENTAGE, Allocation: allocation || [{}], Remainder: remainder || [{ Percentage: 100 }] };

        } else if (transaction) {
            ruleValues = {
                Description: transaction.Description,
                transactionDescription: transaction.Description,
                transactionReference: transaction.TraceID,
                transactionType: transaction.TransactionType,
                transactionAmount: Math.abs(transaction.Amount).toFixed(2),
                MoneyInOut: (transaction.Amount > 0) ? "1" : "0",
                allocateBy: PERCENTAGE
            };

            if (transaction.Coding.length === 0) {
                ruleValues.Allocation = [{}];
                ruleValues.Remainder = [{ Percentage: 100 }];
            } else {
                ruleValues.Allocation = [{}];
                ruleValues.Remainder = transaction.Coding.map(item => ({
                    Amount: Math.abs(item.Amount),
                    Percentage: item.Percentage,
                    AccountCode: item.AccountCode,
                    TaxCode: item.GstCode,
                    Description: item.Description,
                    Classification: item.Classification,
                    Contact: item.Contact
                }));
            }
        }

        return (
            <div>
                <UpdateRuleForm
                    onSubmit={this.handleSaveRule}
                    initialValues={ruleValues}
                    onCancel={closeModal}
                    transactionCodes={transactionCodes}
                    switchRule={this.switchRule}
                    ruleValues={ruleValues}
                    contacts={contacts}
                    isRah={isRah}
                    taxTracking={taxTracking}
                    classification={classification.filter(item => !item.isDisabled)}
                    isCredit={account.isCreditCard && isRah}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        rules: state.rules,
        status: state.status,
        transactionCodes: state.transactions.transactionCodes,
        contacts: state.transactions.contacts,
        classification: state.transactions.classification
    };
}

export default connect(mapStateToProps, actions)(RuleModal);


// WEBPACK FOOTER //
// ./src/components/Rules/RuleModal.js